import Backbone from 'backbone';
import { on, off, getElement } from 'utils/mixins';
var MobileDetect = require('mobile-detect');
const md = new MobileDetect(navigator.userAgent);
const $ = Backbone.$;
let changeIcon = '';

const WidgetGreeting = require('../WidgetGreeting');
const WidgetGreetingModel = require('../../model/WidgetGreeting');
const SelectView = require('../SelectView');
const SelectModel = require('../../model/SelectModel');

module.exports = Backbone.View.extend({
  tagName: 'div',
  template() {
    const chat_bubbles_ic = `${this.conf.domain}img/livechat_widget.svg`;
    const chat_close_ic = `${this.conf.domain}img/close_widget_list.svg`;
    return `<div class="numberMess"><div class="numberText"></div></div>
            <div class="inner_icon" style="border-radius: 30px; overflow: hidden;">
              <img class="chat_bubbles_ic chat-ic" src="${chat_bubbles_ic}" />
              <img class="chat_close_ic chat-ic" src="${chat_close_ic}" />
            </div>`;
  },

  templateFB() {
    const fb_ic = `${this.conf.domain}img/icon-messenger-not-bg.svg`;
    return `<div class="inner_icon" style="border-radius: 30px; overflow: hidden;">
              <img class="chat_fb_ic chat-ic" style="width: 40px; height: 40px;" src="${fb_ic}" />
            </div>`;
  },

  widgetTemplate() {
    const chat_bubbles_ic = `${this.conf.domain}img/livechat_widget.svg`;
    const chat_close_ic = `${this.conf.domain}img/close_widget_list.svg`;
    const widget_ic = `${this.conf.domain}img/icon_widget.svg`;
    const fb_ic = `${this.conf.domain}img/icon-messenger-not-bg.svg`;
    return `<div class="numberMess"></div>
            <div class="inner_icon">
              <img class="chat_widget_ic chat-ic" style="display: block" src="${widget_ic}" />
              <img class="chat_bubbles_ic chat-ic" style="display: none" src="${chat_bubbles_ic}" />
              <img class="chat_fb_ic chat-ic" style="display: none" src="${fb_ic}" />
              <img class="chat_close_ic chat-ic" style="display: none" src="${chat_close_ic}" />
            </div>`;
  },

  initialize(o) {
    _.bindAll(this, 'handleClick', 'handleNumberMessChange', 'handleCloseChat');
    const model = this.model;
    model.view = this;
    this.flag = true;
    this.flagChangeIcon = true;
    this.conf = o.config || {};
    this.flagIcon = o.flag;
    this.pfx = this.conf.stylePrefix || '';

    this.listenTo(model, 'change:isChatOpen', this.handleCloseChat);
  },

  handleNumberMessChange(number) {
    const { $el } = this;
    if (!this.numberMessEl) {
      return;
    }
    if (number > 0) {
      this.numberMessEl
        .html(`<div class="numberText">${number}</div>`)
        .css('display', 'block');
    } else {
      this.numberMessEl.css('display', 'none').html('');
    }

    this.selectView && this.selectView.handleNumberMessChange(number);
  },

  handleClick(e, test) {
    const { model, conf } = this;
    const processing = model.get('processing');
    const isChatOpen = model.get('isChatOpen');
    if (processing) {
      return;
    }
    model.set('processing', false);

    // open select chat
    if (
      conf.isTypeShow === 'podFBAndChat' ||
      conf.isTypeShow === 'tabFBAndChat'
    ) {
      this.handleWidgetClick();
      return;
    }
    if (conf.isTypeShow === 'tabFacebook') {
      window.open(conf.urlFB);
      return;
    }

    if (!isChatOpen) {
      this.showLiveChat();
    } else {
      model.trigger('onChatClose');
    }

    // change chat close status
    model.set('isChatOpen', !isChatOpen);
  },

  /**
   * handle widget click
   */
  handleWidgetClick() {
    const { model, conf } = this;
    const isChatOpen = model.get('isChatOpen');
    const open = model.get('open');
    model.set('processing', true);
    if (open === 'chat') {
      model.trigger('onChatClose');
      this.showWidgetGreeting();
      return;
    }
    this.hideWidgetGreeting(() => {
      if (!isChatOpen) {
        let size_icon = conf.size_icon;
        if (conf.size_icon < 60) {
          size_icon = 60;
        }
        conf.canvas.frame.updateDim(
          `${size_icon + 140}px`,
          `${size_icon + 190}px`
        );

        this.selectView.show();
        setTimeout(() => {
          model.set('processing', false);
        }, 200);
        return;
      }
      // show widget greeting
      this.showWidgetGreeting();

      this.selectView.hide();
    });

    model.set('isChatOpen', !isChatOpen);
  },

  finishClose() {
    const { model } = this;
    this.showWidgetGreeting();
  },

  setBackgroundColor() {
    const { conf } = this;
    if (
      conf.isTypeShow === 'podFBAndChat' ||
      conf.isTypeShow === 'tabFBAndChat'
    ) {
      this.innerIcon.css('background-color', conf.widget_config.frame_color);
      return;
    }
    if (conf.isTypeShow == 'chat' || conf.displayChat) {
      this.innerIcon.css('background-color', conf.header_color);
      return;
    }
    if (conf.isTypeShow == 'tabFacebook') {
      this.innerIcon.css('background-color', conf.messenger_config.frame_color);
      this.innerIcon.css('padding', '10px');
      return;
    }
  },

  /**
   * handle close chat change
   * @param {*} modal
   * @param {*} val
   * @param {*} options
   */
  handleCloseChat(modal, val, options) {
    const { conf, model } = this;
    const chatOpen = model.get('open');
    if (val) {
      if (this.widgetIcon && chatOpen != 'chat') {
        this.widgetIcon.css('display', 'none');
        this.openIc && this.openIc.css('display', 'none');
        this.closeIc && this.closeIc.css('display', 'block');
        return;
      }
      this.openIc && this.openIc.css('display', 'block');
      this.widgetIcon && this.widgetIcon.css('display', 'none');
      this.closeIc && this.closeIc.css('display', 'none');
      return;
    }
    model.set('open', false);

    // close widget
    if (this.widgetIcon) {
      this.widgetIcon.css('display', 'block');
      this.openIc && this.openIc.css('display', 'none');
      this.closeIc.css('display', 'none');
      this.innerIcon.css('background-color', conf.widget_config.frame_color);
      return;
    }
    // close chat
    this.openIc && this.openIc.css('display', 'block');
    this.closeIc && this.closeIc.css('display', 'none');
  },

  /**
   * init  widget greeting
   */
  initWidgetGreeting() {
    const { $el, model, conf } = this;
    this.widgetGreetingModel = new WidgetGreetingModel(conf);
    this.widgetGreeting = new WidgetGreeting({
      model: this.widgetGreetingModel,
      config: conf
    });
    this.widgetGreeting.render();
    conf.canvas.frameBody.append(this.widgetGreeting.el);
    this.listenTo(
      this.widgetGreetingModel,
      'handleCloseGreeting',
      this.closeGreeting
    );
    this.listenTo(
      this.widgetGreetingModel,
      'onContentClick',
      this.handleGreetingClick
    );
    setTimeout(() => {
      this.showWidgetGreeting();
    }, 500);
  },

  /**
   * remove widget greeting
   * @param {*} callback
   */
  closeGreeting(callback) {
    const { conf } = this;
    if (!this.widgetGreeting) {
      callback && callback();
      return;
    }
    this.widgetGreeting.content.css({ opacity: 0, bottom: '85px' });
    setTimeout(() => {
      this.widgetGreeting.$el.remove();
      this.widgetGreeting = null;
      const range_below = conf.range_below - 20;
      const range_vertical = conf.range_vertical - 20;
      let size_icon = conf.size_icon;
      if (conf.chat_box_position === 7 || conf.chat_box_position === 4) {
        conf.canvas.frame.updateDim(
          `${size_icon + 31}px`,
          `${size_icon + 31}px`,
          range_below,
          range_vertical
        );
      } else {
        conf.canvas.frame.updateDim(
          `${size_icon + 31}px`,
          `${size_icon + 31}px`,
          range_below,
          '',
          range_vertical
        );
      }
      setTimeout(() => {
        callback && callback();
      }, 50);
    }, 150);
  },

  /**
   * handle greeting content click
   */
  handleGreetingClick() {
    const { conf } = this;
    if (conf.isTypeShow === 'tabFacebook') {
      window.open(conf.urlFB);
      return;
    }

    if (
      conf.isTypeShow === 'tabFBAndChat' ||
      conf.isTypeShow === 'podFBAndChat'
    ) {
      this.handleWidgetClick();
      return;
    }

    if (conf.isTypeShow === 'chat') {
      this.showLiveChat();
    }
  },

  /**
   * hide widget greeting
   * @param {*} callback
   */
  hideWidgetGreeting(callback) {
    if (!this.widgetGreeting) {
      callback && callback();
      return;
    }
    this.widgetGreeting.content.css({ opacity: 0, bottom: '70px' });
    setTimeout(() => {
      setTimeout(() => {
        callback && callback();
      }, 50);
      this.widgetGreeting.content.css({ display: 'none' });
    }, 150);
  },

  /**
   * show greeting
   */
  showWidgetGreeting() {
    const { conf, model } = this;
    if (!this.widgetGreeting) {
      setTimeout(() => {
        model.set('processing', false);
        this.updateMinimizeFrame();
      }, 300);
      return;
    }

    this.widgetGreeting.display = true;
    this.widgetGreeting.content.css({ display: 'block' });
    setTimeout(() => {
      this.updateMinimizeFrame();
    }, 100);
    const bottom = conf.size_icon + 35;
    setTimeout(() => {
      model.set('processing', false);
      this.widgetGreeting.content.css({ opacity: 1, bottom: `${bottom}px` });
      //this.updateMinimizeFrame();
    }, 200);
  },

  /**
   * update minimize frame size
   */
  updateMinimizeFrame() {
    const { conf } = this;
    const range_below = conf.range_below - 20;
    const range_vertical = conf.range_vertical - 20;
    let size_icon = conf.size_icon;
    if (conf.size_icon < 60) {
      size_icon = 60;
    }
    if (this.widgetGreeting) {
      if (conf.chat_box_position === 7 || conf.chat_box_position === 4) {
        conf.canvas.frame.updateDim(
          `${size_icon + 290}px`,
          `${size_icon + 140}px`,
          range_below,
          range_vertical,
          ''
        );
      } else {
        conf.canvas.frame.updateDim(
          `${size_icon + 290}px`,
          `${size_icon + 140}px`,
          range_below,
          '',
          range_vertical
        );
      }
      return;
    }
    if (conf.chat_box_position === 7 || conf.chat_box_position === 4) {
      conf.canvas.frame.updateDim(
        `${size_icon + 31}px`,
        `${size_icon + 31}px`,
        range_below,
        range_vertical
      );
    } else {
      conf.canvas.frame.updateDim(
        `${size_icon + 31}px`,
        `${size_icon + 31}px`,
        range_below,
        '',
        range_vertical
      );
    }
  },

  /**
   * initialize select view
   */
  initSelectView() {
    const { $el, model, conf } = this;
    this.selectModel = new SelectModel(conf);
    this.selectView = new SelectView({
      model: this.selectModel,
      config: conf
    });
    this.selectView.render();
    conf.canvas.frameBody.append(this.selectView.el);
    // if (this.selectView) {
    //   this.selectView.handlenumberMess(number);
    // }
    this.listenTo(
      this.selectModel,
      'handleClickChat',
      this.handleWidgetChatClick
    );
    this.listenTo(this.selectModel, 'btnMess', this.handleWidgetFBClick);
  },

  /**
   * handle facebook chat click
   */
  handleWidgetFBClick() {
    const { model, conf } = this;
    if (conf.isTypeShow === 'tabFBAndChat') {
      window.open(conf.urlFB);
      return;
    }
    // show messenger FB
    showFBMessenger();

    setTimeout(() => {
      model.set('isChatOpen', false);
      model.set('processing', false);
      model.set('open', false);
    }, 150);

    this.showWidgetGreeting();
    // Hide select view
    this.selectView.hide();

    this.widgetIcon.css('display', 'block');
    this.openIc && this.openIc.css('display', 'none');
    this.closeIc.css('display', 'none');
    this.innerIcon.css('background-color', conf.widget_config.frame_color);
  },

  /**
   * handle chat click event
   */
  handleWidgetChatClick() {
    const { conf, model } = this;
    setTimeout(() => {
      // conf.canvas.frame.updateDim('75px', '75px');
      this.updateMinimizeFrame();
      model.trigger('onChatOpen');
    }, 150);
    this.selectView && this.selectView.hide();
    // reset processing
    setTimeout(() => {
      model.set('processing', false);
    }, 200);
    // show chat icon
    this.showChatIcon();
    model.set('open', 'chat');
  },

  /**
   * show chat icon
   */
  showChatIcon() {
    const { conf } = this;
    this.openIc.css({ display: 'block' });
    this.closeIc.css({ display: 'none' });
    this.innerIcon.css('background-color', conf.header_color);
  },

  showLiveChat() {
    this.hideWidgetGreeting(() => {
      this.handleWidgetChatClick();
    });
  },

  /**
   * render content
   */
  renderContent() {
    const { $el, model, conf } = this;
    if (conf.isTypeShow == 'facebook') {
      return;
    }
    // set template widget
    if (
      conf.isTypeShow === 'podFBAndChat' ||
      conf.isTypeShow === 'tabFBAndChat'
    ) {
      $el.html(this.widgetTemplate());
      this.widgetIcon = $el.find('.chat_widget_ic');
    } else if (conf.isTypeShow === 'tabFacebook') {
      $el.html(this.templateFB());
    } else {
      $el.html(this.template());
    }

    setTimeout(() => {
      this.setBackgroundColor();
    }, 250);

    $el.on('click', this.handleClick);

    this.fbIc = $el.find('.chat_fb_ic');
    this.openIc = $el.find('.chat_bubbles_ic');
    this.closeIc = $el.find('.chat_close_ic');
    this.numberMessEl = $el.find('.numberMess');
    this.innerIcon = $el.find('.inner_icon');
  },

  /**
   * render
   */
  render() {
    const { $el, model, conf } = this;
    this.flagChangeIcon = true;
    $el.attr({ class: `${this.pfx}minimize` });
    const size = (conf.size_icon + 15) / 75;
    if (
      this.conf.chat_box_position === 9 ||
      this.conf.chat_box_position === 6
    ) {
      $el.css({
        transform: `scale(${size},${size})`,
        'transform-origin': 'bottom right'
      });
      $el.css({ right: '16px', bottom: '16px' });
    } else if (
      this.conf.chat_box_position === 7 ||
      this.conf.chat_box_position === 4
    ) {
      $el.css({
        transform: `scale(${size},${size})`,
        'transform-origin': 'bottom left'
      });
      $el.css({ left: '16px', bottom: '16px' });
    } else {
      $el.css({ right: '16px', bottom: '16px' });
    }

    // render content
    this.updateMinimizeFrame();
    this.renderContent();
    if (
      conf.widget_setting.popup_message_on &&
      (conf.isTypeShow == 'chat' ||
        conf.isTypeShow == 'tabFacebook' ||
        (conf.widget_config.messenger && conf.widget_config.mobiochat))
    ) {
      this.initWidgetGreeting();
    }

    if (
      conf.isTypeShow === 'podFBAndChat' ||
      conf.isTypeShow === 'tabFBAndChat'
    ) {
      this.initSelectView();
    }
    return this;
  }
});
